import React from "react";
import { FileTextIcon, FlaskConicalIcon, Grid3x3Icon, LibraryIcon, MicroscopeIcon } from "lucide-react";
import { CtaButton } from "../CtaButton";
import { SectionHeading } from "../SectionHeading";
import { resources } from "../../data/content";
const iconMap = {
  flask: FlaskConicalIcon,
  grid: Grid3x3Icon,
  file: FileTextIcon,
  library: LibraryIcon,
  microscope: MicroscopeIcon
} as const;
export function Resources() {
  return <section className="w-full bg-brand-lilac px-5 py-16 md:py-24" data-id="element-277" data-mp="1ixvppe0a7fqv">
      <div className="mx-auto max-w-3xl" data-id="element-278" data-mp="1ex21skmua0xz">
        <SectionHeading eyebrow="And that's not all…" title="Tools to actually use the system — not just read it" data-id="element-279" data-mp="1ew0la0n20m8v" />

        <ul className="mt-10 divide-y divide-brand-lavender/20 rounded-3xl bg-paper px-5 md:px-8" data-id="element-280" data-mp="1nqeyzyrxropv">
          {resources.map(r => {
          const Icon = iconMap[r.icon as keyof typeof iconMap];
          return <li key={r.title} className="flex gap-4 py-5" data-id="element-281" data-mp="1xpe08wadgi2u">
                <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-brand-lilac text-brand-lavender" data-id="element-282" data-mp="1xmrtuzz7w8m7">
                  <Icon className="h-6 w-6" aria-hidden="true" data-id="element-283" data-mp="1fhl0oxjtqs7a" />
                </span>
                <div data-id="element-284" data-mp="1jjgc4uvgylys">
                  <h3 className="font-serif text-xl font-bold text-ink" data-id="element-285" data-mp="1jiwrh6efpjh2">{r.title}</h3>
                  <p className="mt-1 text-[16px] leading-relaxed text-ink/75" data-id="element-286" data-mp="1ojb3ezj5pdkd">{r.body}</p>
                </div>
              </li>;
        })}
        </ul>

        <div className="mt-10 text-center" data-id="element-287" data-mp="1tgb5z0gsry6q">
          <p className="text-[17px] text-ink/80 md:text-lg" data-id="element-288" data-mp="1yg72yfr2upcs">
            And here's the best part… you can come back to the system every time you want to create something new.
          </p>
          <p className="mt-5 font-serif text-2xl font-bold leading-snug text-brand-olive md:text-3xl" data-id="element-289" data-mp="279shbxzby4lo">
            One formula can inspire another.
            <br data-id="element-290" data-mp="2c6ixsmf1r27m" />
            One product can become a collection.
            <br data-id="element-291" data-mp="2h8i1xyim235m" />
            <span className="italic text-brand-lavender" data-id="element-292" data-mp="2h7zwcba26cl1">One collection can become a brand.</span>
          </p>
        </div>

        <div className="mt-10" data-id="element-293" data-mp="h34h4unpg6n1">
          <CtaButton label="I Want Access to the Full System" data-id="element-294" data-mp="c75jegghlc9y" />
        </div>
      </div>
    </section>;
}